import template from "./accessibility-modal.html";
import "./accessibility-modal.less";
import { EVENT_LOGOUT } from "../../../constants";

export class Controller {
	constructor(appState, eventBus, $scope, $userProfile, hotkeys) {
		this.appState = appState;
		this.eventBus = eventBus;
		this.$scope = $scope;
		this.$userProfile = $userProfile;
		this.hotkeys = hotkeys;
	}

	$onInit() {
		this.userProfile = this.$userProfile.getUserProfile();
		this.shortcutsEnabled = this.userProfile.shortcutsEnabled;
		this.eventBus.register(EVENT_LOGOUT, () => {
			this.handleClose();
		}, this.$scope);
	}

	handleClose() {
		this.modalInstance.dismiss();
	}

	handleShortcutsToggle() {
		this.userProfile.shortcutsEnabled = this.shortcutsEnabled;
		this.$userProfile.setUserProfile(this.userProfile);

		if(this.userProfile.shortcutsEnabled) {
			this.hotkeys.unpause();
		}
		else {
			this.hotkeys.pause();
		}
	}
}

export default angular
	.module("vesl.components.accessibility-modal", [])
	.component("accessibilityModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
